<table mat-table [dataSource]="data.remarks" [style.width.%]="100">
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>Date Added</th>
    <td mat-cell *matCellDef="let element">{{ element.dateAdded | date }}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Remark</th>
    <td mat-cell *matCellDef="let element">{{ element.comment }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<button class="mt-5" mat-raised-button (click)="dialogRef.close()">Close</button>
